import {ApiBase} from "./api.base";
import {PageInfo} from "./pageInfo.ts";

export enum ApiEndpoint {
    PAGES = "/api/pages",
}

export class Api extends ApiBase {
    static getPages() {
        return this.get<PageInfo[]>(ApiEndpoint.PAGES);
    }
}
